<template>
  <div>
    <v-card
      :style="[
        $vuetify.breakpoint.height < 786
          ? { 'min-height': '100vh', 'background-color': BackgroundColor }
          : $vuetify.breakpoint.height >= 947
          ? { 'min-height': '91vh', 'background-color': BackgroundColor }
          // : $vuetify.breakpoint.height == 969
          // ? { 'min-height': '91vh', 'background-color': BackgroundColor }
          // : $vuetify.breakpoint.height == 929
          // ? { 'min-height': '91vh', 'background-color': BackgroundColor }
          : { height: 'auto', 'background-color': BackgroundColor },
      ]"
    >
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          style="
            font-size: 18px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
            cursor: default;
            margin-top: -1rem;
          "
        ></div>
        <v-card-text>
          <div>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="8" align="center">
                <v-text-field
                  class="centered-input-header"
                  :value="
                    SiteName == '' || MainPageActiveStatus == false
                      ? 'Forward System Co.,Ltd.'
                      : SiteName
                  "
                  disabled
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="4" align="center">
                <p style="text-align: center; font-size: 22px; color: #14223c">
                  {{ $t("message.VehicleType") }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" align="center"></v-col>
              <v-col cols="12" md="3" align="center">
                <v-card
                  height="170"
                  style="cursor: pointer"
                  @click="SearchParking(1)"
                >
                  <v-img :src="CarLogo" height="120" width="120"></v-img>
                  <p
                    style="text-align: center; font-size: 22px; color: #14223c"
                  >
                    {{ $t("message.Car") }}
                  </p>
                </v-card>
              </v-col>
              <v-col cols="12" md="3" align="center">
                <v-card
                  height="170"
                  style="cursor: pointer"
                  @click="SearchParking(2)"
                >
                  <v-img :src="MotorcycleLogo" height="120" width="120"></v-img>
                  <p
                    style="text-align: center; font-size: 22px; color: #14223c"
                  >
                    {{ $t("message.Motorcycle") }}
                  </p>
                </v-card>
              </v-col>
              <v-col cols="12" md="3"></v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="4" align="center">
                <v-btn
                  height="40"
                  width="150"
                  outlined
                  color="indigo"
                  @click="BackToMain()"
                >
                  {{ $t("message.Back") }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="LoadingDialog" persistent width="0.01">
      <v-card>
        <v-card-text>
          <v-row>
            <LoadingComponent class="centered"></LoadingComponent>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <br />
    <v-footer
      :color="
        ThemeColor == '' || ActiveStatus == false ? '#1d2939' : ThemeColor
      "
      :absolute="$vuetify.breakpoint.height < 786 ? false : true"
      class="white--text text-caption footer"
    >
      <v-row no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-row no-gutters>
            <v-col cols="12" xs="12" sm="4" md="4" lg="2"> </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" lg="8">
              <div class="d-flex mt-2">
                <span style="font-size: small; margin-bottom: 5px; color: white"
                  >Copyright © 2023 Forward System Co. Ltd. All rights reserved.</span
                >
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" xs="12" sm="2" md="2"> </v-col>
      </v-row>
    </v-footer>

    <AlertComponent
      :flagAlert="AlertDialog"
      :typeAlert="TypeAlert"
      :mesAlert="MessageAlert"
      @flagClose="ClearDataAlert()"
    />
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import AlertComponent from "@/components/Alert";
import LoadingComponent from "@/components/Loading";
export default {
  name: "VehicleType",
  components: {
    AlertComponent,
    LoadingComponent,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      model: "tab-1",
      SearchInput: "",
      QRCodeData: "",
      id: null,
      destroy: false,
      Status: false,
      response: "",
      ColorTab: "#126496",
      ColorText: "#126496",
      ColorText2: "",

      CheckPermissionDialog: false,
      UserAdmin: "",
      PasswordAdmin: "",
      SettingMainDialog: false,
      ThemeColor: "",
      ActiveStatus: false,
      SiteName: "",
      SiteNameColor: "",
      BackgroundColor: "",
      MainPageActiveStatus: false,

      CarLogo: require("@/assets/car.png"),
      MotorcycleLogo: require("@/assets/motorcycle.png"),
      LogCarparkID: 0,
    };
  },

  computed: {},
  
  watch: {},

  methods: {
    async LoadDataSettingMainPage() {
      let self = this;
      await axios
        .get(`${self.url}Setting/LoadDataSettingMainPage`)
        .then(function (response) {
          if (response.data.status == 0) {
            if (response.data.data.activeStatus == true) {
              self.SiteName = response.data.data.siteName;
              self.SiteNameColor = response.data.data.siteNameColor;
              self.BackgroundColor = response.data.data.backgroundColor;
              self.MainPageActiveStatus =
                response.data.data.activeStatus == true ? "1" : "2";
            }
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
        });
    },
    async LoadDataSettingLogin() {
      let self = this;
      await axios
        .get(`${self.url}Setting/LoadDataSettingLogin`)
        .then(function (response) {
          if (response.data.status == 0) {
            if (response.data.data.activeStatus == true) {
              self.ActiveStatus = response.data.data.activeStatus;
              self.ThemeColor = response.data.data.themeColor;
            }
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
        });
    },

    SearchParking(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        LogCarparkID: self.LogCarparkID,
        VehicleType: value == 1 ? "0" : "1",
      };
      axios
        .post(`${self.url}Redemption/GetParkingDetailFromVehicleType`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.response = response.data.data;
            self.LoadingDialog = false;
            self.$router.push({
              name: "ParkingInformation",
              params: { response: self.response, LogID: self.LogCarparkID },
            });
          } else {
            self.LoadingDialog = false;
            self.MessageAlert = response.data.message;
            self.TypeAlert = "error";
            self.AlertDialog = true;
          }
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          self.MessageAlert = error;
          self.TypeAlert = "error";
          self.AlertDialog = true;
        });
    },

    ClearDataAlert() {
      let self = this;
      self.AlertDialog = false;
      self.TypeAlert = "";
      self.MessageAlert = "";
    },

    BackToMain() {
      let self = this;
      self.$router.push("/Main");
    },
  },

  async mounted() {
    await this.LoadDataSettingMainPage();
    this.LogCarparkID = this.$route.params.input;
  },
};
</script>
<style scoped>
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
  color: black;
}
@font-face {
  font-family: "English";
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
